// Effets partagés par les easter eggs du site (confettis, aboiement, ballon…).
import './easterEggs.css';

const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const CONFETTI_COLORS = ['#FC6200', '#e3a72f', '#FFA6B4', '#6e7f4f', '#ffffff'];

// Pluie de confettis (ou d'emojis si `emojis` est fourni) sur tout l'écran.
export function launchConfetti({ emojis = null, count = 90 } = {}) {
  if (reducedMotion()) {
    return;
  }
  const layer = document.createElement('div');
  layer.className = 'confetti-layer';
  layer.setAttribute('aria-hidden', 'true');

  for (let i = 0; i < count; i += 1) {
    const piece = document.createElement('span');
    piece.className = emojis ? 'confetti-emoji' : 'confetti-piece';
    if (emojis) {
      piece.textContent = emojis[i % emojis.length];
    } else {
      piece.style.background = CONFETTI_COLORS[i % CONFETTI_COLORS.length];
    }
    piece.style.left = `${Math.random() * 100}%`;
    piece.style.setProperty('--sway', `${Math.random() * 160 - 80}px`);
    piece.style.setProperty('--spin', `${Math.random() * 720 - 360}deg`);
    piece.style.animationDelay = `${Math.random() * 0.8}s`;
    piece.style.animationDuration = `${2.2 + Math.random() * 1.6}s`;
    layer.appendChild(piece);
  }

  document.body.appendChild(layer);
  setTimeout(() => layer.remove(), 5000);
}

// Petit « wouf » synthétisé, pour ne pas dépendre d'un fichier audio.
let audioContext;
export function playBark() {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) {
    return;
  }
  audioContext = audioContext || new AudioCtx();
  const ctx = audioContext;
  const now = ctx.currentTime;

  [0, 0.18].forEach((delay, i) => {
    const osc = ctx.createOscillator();
    const filter = ctx.createBiquadFilter();
    const gain = ctx.createGain();
    osc.type = 'sawtooth';
    osc.frequency.setValueAtTime(i === 0 ? 520 : 440, now + delay);
    osc.frequency.exponentialRampToValueAtTime(140, now + delay + 0.14);
    filter.type = 'lowpass';
    filter.frequency.value = 1200;
    gain.gain.setValueAtTime(0.0001, now + delay);
    gain.gain.exponentialRampToValueAtTime(0.35, now + delay + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + delay + 0.16);
    osc.connect(filter).connect(gain).connect(ctx.destination);
    osc.start(now + delay);
    osc.stop(now + delay + 0.18);
  });
}

// Fait sauter de joie un sticker (écouté par le composant Stickers).
export const STICKER_JOY_EVENT = 'sticker-joy';
export function celebrateSticker(name) {
  window.dispatchEvent(new CustomEvent(STICKER_JOY_EVENT, { detail: name }));
}

// Balle au prisonnier : un ballon arrive sur la card, rebondit, « BONK ».
export function throwBall(card) {
  if (!card || card.querySelector('.dodgeball')) {
    return;
  }
  const ball = document.createElement('span');
  ball.className = 'dodgeball';
  ball.textContent = '🏐';
  ball.setAttribute('aria-hidden', 'true');
  card.appendChild(ball);

  const width = card.offsetWidth;
  const impact = 550;
  const animation = ball.animate(
    [
      { transform: `translate(${-width * 0.6}px, -60px) rotate(0deg)`, offset: 0 },
      { transform: `translate(${width * 0.45}px, 10px) rotate(360deg)`, offset: 0.4 },
      { transform: `translate(${width * 0.2}px, -120px) rotate(520deg)`, offset: 0.7 },
      { transform: `translate(${-width * 0.4}px, 60px) rotate(700deg)`, offset: 1, opacity: 0 },
    ],
    { duration: impact / 0.4, easing: 'ease-in-out' }
  );

  setTimeout(() => {
    const bonk = document.createElement('span');
    bonk.className = 'dodgeball-bonk';
    bonk.textContent = 'BONK\u00A0!';
    bonk.setAttribute('aria-hidden', 'true');
    card.appendChild(bonk);
    card.classList.add('card-shake');
    setTimeout(() => {
      bonk.remove();
      card.classList.remove('card-shake');
    }, 900);
  }, impact);

  animation.onfinish = () => ball.remove();
}
